import loadable from 'components/dynamic-import';

export const ApprovedNotification = loadable(() => import('./ApprovedNotification'));
